export default {"src":"/_next/static/media/pool.baad7a7f.svg","height":40,"width":55,"blurWidth":0,"blurHeight":0};